import { Row, Col, Card } from "react-bootstrap";
import PropertyFilter from "../components/PropertyFilter";
// import heroImg from '../assets/images/7.jpg';
import '../assets/scss/pages/home.scss';

function Hero() {
    return (
        <Row as="section" className="home-section hero mb-sm-5 mb-lg-4 mt-0">
            {/* Banner */}
            <Card className="d-flex flex-column px-0 mx-0">
                <Card.Img />
                <Card.ImgOverlay as={Col} xs={10} sm={8} md={6} lg={6} xl={5} xxl={5} className="d-flex flex-column py-5 px-sm-1 px-md-3 px-lg-4 px-xl-5">
                    <Card.Title as="h1" className="my-xs-3 my-sm-3 my-md-3 my-lg-4 my-xl-4 my-xxl-4">Welcome to <br />AFINNEY REALTY</Card.Title>
                    <Card.Text>Connecting you to premium properties and seamless buying experiences.</Card.Text>
                </Card.ImgOverlay>
            </Card>

            {/* Filter section */}
            <PropertyFilter filters={{ }} hero={true} />
        </Row>
    )
}

export default Hero;
